require("../polyfills/element.matches");
require("../polyfills/element.closest");

module.exports = function(options) {

    const _this = this;
    const events = require("../helpers/events");
    const responsive = require("../nav_tree/responsiveBreadcrumb");

    let listeners = {
        click: []
    };
    let element;

    this.click = function(fn) {
        listeners.click.push(fn);
        return this;
    };

    this.getElement = function() {
        return element;
    };

    this.delegateCrumbClick = function(event) {
        event.preventDefault();
        event.navtree = {
            closeNavTree: false
        };

        for (let i = 0; i < listeners.click.length; i++) {
            listeners.click[i].call(_this, this.dataset.levelId, this, event);
        }
    };

    this.updateResponsive = function(event, breadcrumbElem) {
        // @todo I'm always getting breadcrumbElem as undefined. However, it doesn't break anything since it's option.
        responsive.setBreakpointsDynamically(breadcrumbElem);
    };

    this.init = function(elem) {
        element = elem;

        const breadcrumb = document.getElementById("breadcrumb");
        if (breadcrumb) {
            const dis = breadcrumb.getElementsByClassName("disabled");
            if (dis && dis.length > 0 && mediatelHomeUrl) {
                // we have at least one NOT ALLOWED node, so we should redirect user to main page
                document.location.href = mediatelHomeUrl + "/connected-app";
            }
        }

        events.addEvent(element, "click", function (event) {
            events.delegateEvents.call(this, event, {
                ".crumb": _this.delegateCrumbClick
            });
        });

        this.updateResponsive(element);
    }
};
